//
// Device platform util
// -----------

define(function(require, exports, module) {
    'use strict';

    var url = require('util/url.util');
    var deviceCommon = require('util/device.common.util');

    module.exports = {

        DEFAULT_DELIVERY_PLATFORM: 'Hub2',

        /**
         * Supported values for clientPlatform GET parameter
         */
        _supportedClientPlatformParams: [
            'ivr', // Interactive Voice Response
            'smsbetting', // SMS Betting
            'retailotc', // Retail Over The Counter
            'download', // Download
            'retailbip', // Retail Bet in Play
            'telebet', // Telebet
            'flash', // Flash
            'oncourse', // On Course
            'retailterminal', // Retail Terminal
            'system', // System
            'admin' // Admin
        ],

        _clientPlatform: null,

        /**
         * Detects client platform to send to the IMS
         * @return {String}
         */
        get clientPlatform() {
            if (this._clientPlatform) {
                return this._clientPlatform;
            }

            var clientPlatformFromUrl = url.getLocationParameterByName('clientPlatform');

            this._clientPlatform = this._supportedClientPlatformParams.includes(clientPlatformFromUrl) ?
                clientPlatformFromUrl : deviceCommon.formFactor === 'desktop' ? 'web' : 'mobile';

            return this._clientPlatform;
        },

        /**
         * Check is client is download
         * @return {Boolean}
         */
        isDownloadClient: function() {
            return this.clientPlatform === 'download';
        },

        get isMobilePlatform() {
            return deviceCommon.formFactor !== 'desktop';
        },

        /**
         * Detect device delivery platform
         * @return {String}
         */
        get deliveryPlatform() {
            return url.getLocationParameterByName('deliveryPlatform') || this.DEFAULT_DELIVERY_PLATFORM;
        },

        get isNotHUB2Platform() { // related to COR-13181
            return Boolean(url.getLocationParameterByName('deliveryPlatform'));
        }

    };

});
